<style>
  .v-list--dense .v-list-item .v-list-item__title.notInitialized {
    color: grey;
    font-weight: normal;
  }

  .v-list-item__title.notInitialized .v-stepper__step__step {
    border: 1px solid #bababa;
    color: #bababa;
  }
  .v-list-item__title .v-stepper__step__step {
    border: 1px solid #5f5f5f;
    color: #5f5f5f;
  }

  .v-list-item__title .v-input--selection-controls__input {
    margin-right: 0;
  }

  .section-settings-container {
    display: flex;
    justify-content: center;
    width: 90%;
    transition-property: width, opacity, height, margin-top;
    transition-duration: 150ms, 180ms, 100ms;
    transition-timing-function: ease-out;
    margin-left: auto;
    margin-right: auto;
    opacity: 1;
    max-width: 800px;
  }

  .section-settings-container.active {
    margin-top: 0px;
    width: 100%;
    opacity: 0;
  }

  @media (max-width: 959px) {
    .template-container {
      width: 100%;
    }
  }

  @media (min-width: 960px) {
    .template-container {
      display: flex;
      justify-content: center;
      width: 100%;
    }
  }

  .container-template {
    display: flex;
    justify-content: center;
    min-height: 100vh;
    background-color: #f1f5f9;
    @media (min-width: 960px) {
      width: 100%;
      background-color: #f1f5f9;
    }
  }

  .container-template.wizard-enabled {
    justify-content: inherit;
  }
</style>

<template>
  <v-container
    class="container-template"
    :class="$store.state.activeTemplate.uuid && $store.state.activeTemplate.isWizardEnabled && 'wizard-enabled'"
    fluid
    v-scroll="onScroll"
    v-resize="onResize"
  >
    <v-row v-if="$store.state.loading"
      justify="center"
      alignContent="center"
    >
      <v-col cols="12" md="6">
        <div style="display: flex; justify-content: center; margin-bottom: 60px;">
          <v-progress-circular
            color="red"
            :size="50"
            :width="3"
            indeterminate
            class="v-progress-circular--visible"
          ></v-progress-circular>
        </div>

        <div style="text-align: center;">
          <div style="margin: 20px 0 5px; font-size: 26px;">
            {{ splashTitle }}
          </div>
        </div>
      </v-col>
    </v-row>

    <div
      v-if="!$store.state.loading && $store.state.activeTemplate.uuid"
      class="template-container"
      no-gutters
    >
      <TemplatePreview/>
    </div>

    <v-dialog
      max-width="500px"
      v-model="$store.state.dialogs.showGSUrlDialogVisible"
    >
      <v-card elevation="5" style="padding: 10px 10px 30px;">
        <v-card-title style="justify-content: center;">
          {{ translate('ui_gs_file_ready') }}
        </v-card-title>
        <v-card-actions style="display: flex; justify-content: center; margin: 20px 0 0;">
          <v-btn
            @click="closeShowGSUrlDialogVisible"
            color="primary"
            style="padding: 17px 12px;"
            :href="$store.state.dialogs.GSUrl"
            target="_blank"
          >
            <v-icon light style="margin-right: 10px;">mdi-google-spreadsheet</v-icon>
            {{ translate('ui_gs_file_url') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="$store.state.dialogs.snackbar"
      color="success"
      :timeout="$store.state.loginReminderProgressInitValue * 1000"
      style="max-width: 90%; width: 300px; margin: 0 auto 20px;"
      :multi-line="true"
    >
      <div style="display: flex; flex-direction: column;">
        <div style="display: flex; align-items: center;">
          <div style="padding-right: 30px;">{{ translate('ui_save_your_work') }}</div>
          <div>
            <a href="https://www.finmodelbuilder.com/builder/#/" style="text-decoration: none;">
              <v-btn
                outlined
                style="margin-left: 0;"
              >
                <v-icon>mdi-key</v-icon>
              </v-btn>
            </a>
          </div>
        </div>
        <div>
          <v-checkbox
            v-model="$store.state.user.settings.showLoginReminder"
            hide-details
            color="white"
            small
          >
            <template v-slot:label>
              <span style="color: #fff; font-size: 12px;">
                {{ translate('ui_show_warning') }}
              </span>
              <v-progress-circular
                size="20"
                width="1"
                color="white"
                :rotate="-90"
                :value="(1 - $store.state.loginReminderProgressCurrentValue /
                $store.state.loginReminderProgressInitValue) * 100"
                style="margin-left: auto; font-size: 10px;"
              >
                {{ loginReminderProgressValue }}
              </v-progress-circular>
            </template>
          </v-checkbox>
        </div>
      </div>
    </v-snackbar>

  </v-container>
</template>

<script>

// import storeUtils from '@/store/storeUtils';
import TemplatePreview from './TemplatePreview.vue';

// mixins
import Mixin from '../../mixins/mixin';

export default {
  components: {
    TemplatePreview,
  },
  mixins: [Mixin],
  props: {},
  data: () => ({
    activeTemplate: null,
    navContainerEl: null,
    scrollTimer: null,
  }),
  methods: {
    closeShowGSUrlDialogVisible() {
      this.$store.commit('updateState', {
        path: 'dialogs.showGSUrlDialogVisible',
        value: false,
      });
    },
    onScroll() {
      if (this.$store.state.mode === 'static') {
        return;
      }
      clearTimeout(this.scrollTimer);
      // delay new call 500ms
      this.scrollTimer = setTimeout(() => {
        if (this.$store.state.activeTemplate && !this.$store.state.activeTemplate.showOnboardingDialog) {
          const sectionElements = [...document.querySelectorAll('.section-container')]; // Select all elements
          const currentSection = sectionElements.find((section) => {
            const rect = section.getBoundingClientRect();
            // Check if the element is in the viewport and its top is closest to 0
            // if more than 100px is visible - grab it
            return rect.bottom > 300;
          });
          if (currentSection) {
            this.$store.dispatch('updateState', {
              path: 'activeTemplate.data.activeSectionId',
              value: currentSection.id,
            });
          }
        }
      }, 100);
    },
    onResize() {
      // let timerId;
      // const debounced = () => {
      //   // cancel pending call
      //   clearTimeout(timerId);
      //
      //   // delay new call 500ms
      //   timerId = setTimeout(() => {
      //     this.$store.dispatch('moveNavigator', {
      //       breakpoint: this.$vuetify.breakpoint,
      //     });
      //   }, 500);
      // };
      // debounced();
    },
  },
  computed: {
    loginReminderProgressValue() {
      return this.$store.state.loginReminderProgressCurrentValue;
    },
    splashTitle() {
      const { language } = this.$store.state.user.settings;
      const { languages } = this.$store.state;
      const result = languages ? this.translate('ui_splash_title', language) : '';
      // might not be ready yet, so don't show anything
      return result === 'ui_splash_title' ? '' : result;
    },
  },
  created() {},
  async mounted() {
    if (window.template) {
      // TODO - need to redo below
      // mark all preview sections isInitialized
      // const { previewModules } = this.$store.state;
      // previewModules.forEach((previewModule) => {
      //   // eslint-disable-next-line
      //   previewModule.isInitialized = true;
      // });
      // this.$store.dispatch('updateState', {
      //   path: 'defaultTemplateConfig',
      //   value: window.template.defaultTemplateConfig,
      // });
      const { template } = window.template;
      await this.$store.dispatch('getStaticTemplate', template);
      if (template.previewData) {
        // wait for the page to fully load
        setTimeout(() => {
          this.$store.dispatch('updatePreviewDataHTML', template.previewData);
          this.$store.dispatch('updateState', {
            path: 'isPreviewDataLoaded',
            value: true,
          });
        }, 0);
      } else {
        this.$store.dispatch('previewModel');
      }
    } else {
      // load template
      const currentActiveTemplateId = this.$store.state.activeTemplate && this.$store.state.activeTemplate.uuid;
      const templateId = this.$route.name === 'new' ? 'new' : this.$route.params.id;
      if (currentActiveTemplateId !== templateId) {
        this.$store.dispatch('updateState', {
          path: 'loading',
          value: true,
        });

        setTimeout(async () => {
          await this.$store.dispatch('getTemplate', {
            templateId,
          });

          this.$store.dispatch('updateState', {
            path: 'loading',
            value: false,
          });

          // don't preview is just a new template
          if (templateId !== 'new') {
            this.$store.dispatch('previewModel');
          }
        }, 300);
      }
    }
  },
};

</script>
